import React from 'react';
import { User } from 'src/store/models/user.model';
import RegisterForm from '../register-form.component';

type ResetPassFormProps = {
  userProfile: User;
  callBack?: () => void;
};

const ResetPassForm: React.FC<ResetPassFormProps> = ({ userProfile, callBack }) => {
  const handleFormCallBack = (): void => {
    callBack && callBack();
  };
  return <RegisterForm user={userProfile} isResetPassword callBack={handleFormCallBack} />;
};
export default ResetPassForm;
